import React from "react";
import "../styles/showCard.scss";

/**
 * ShowCard — Thumbnail card for shows/movies in content rows
 * Figma: Home Screen content row items
 *
 * Variants:
 *   - "poster" (default): Tall poster (185×278) for movies/shows
 *   - "landscape": Wide thumbnail (320×180) for episodes/continue watching
 *   - "brand": Square-ish (140×80) for brand logos
 *
 * @param {string} title - Show/movie title
 * @param {string} image - Poster/thumbnail image URL
 * @param {string} subtitle - Optional subtitle (e.g., "S1 E1")
 * @param {string} variant - "poster" | "landscape" | "brand"
 * @param {number} progress - 0-100 progress bar percentage (for continue watching)
 * @param {function} onClick - Click handler
 */
const ShowCard = ({
  title,
  image,
  subtitle,
  description,
  variant = "poster",
  progress,
  onClick,
}) => {
  return (
    <div
      className={`mango-show-card mango-show-card--${variant}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {/* Thumbnail */}
      <div className="mango-show-card__thumb">
        {image ? (
          <img src={image} alt={title} className="mango-show-card__img" />
        ) : (
          <div className="mango-show-card__placeholder">
            <span>{title}</span>
          </div>
        )}

        {/* Progress bar (continue watching) */}
        {typeof progress === "number" && (
          <div className="mango-show-card__progress">
            <div
              className="mango-show-card__progress-bar"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </div>

      {/* Title & subtitle (hidden for brand variant) */}
      {variant !== "brand" && (
        <div className="mango-show-card__info">
          {title && <span className="mango-show-card__title">{title}</span>}
          {description && (
            <span className="mango-show-card__description">{description}</span>
          )}
          {subtitle && (
            <span className="mango-show-card__subtitle">{subtitle}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowCard;
